



















import Vue from 'vue';

export default Vue.extend({
  name: 'ZenLink',
  props: {
    to: {
      type: String,
      required: true,
    },
  },
  computed: {
    clientRoutable(): boolean {
      return this.$router && this.$router.resolve(this.to).resolved.name !== 'error404';
    },
  },
  methods: {
    checkSameRoute(event: MouseEvent) {
      if (event && this.$route.path === (<HTMLAnchorElement>event.target).pathname) {
        let count: number = this.$store.getters.routeLoadCount;
        this.$store.commit('SET_ROUTE_LOAD_COUNT', count + 1);
      } else {
        this.$store.commit('SET_ROUTE_LOAD_COUNT', 0);
      }
    },
  },
});
